// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"0198bd21","578":"3fbe476b","952":"7ab6afb7","972":"477c67dd"}[chunkId] + ".chunk.js";
};